"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AdtFlag_1 = require("./AdtFlag");
/**
 * Set of extendable flagSet.
 * @author SMi
 */


var FlagSet =
/*#__PURE__*/
function () {
  function FlagSet(base) {
    _classCallCheck(this, FlagSet);

    this.base = base;
    this.flags = new Map();
    /**/
  }

  _createClass(FlagSet, [{
    key: Symbol.iterator,
    value: function value() {
      return this.flags.values();
    }
  }, {
    key: "get",
    value: function get(ctor) {
      var f = this.flags.get(ctor);
      return f ? f : null;
    }
  }, {
    key: "has",
    value: function has(ctor) {
      return this.flags.has(ctor);
    }
  }, {
    key: "size",
    value: function size() {
      return this.flags.size;
    }
  }, {
    key: "add",
    value: function add(flag) {
      var ctor = flag.constructor;

      if (typeof ctor !== 'function' || !ctor.TAG) {
        throw new Error('Provided value is not ADT flag');
      }

      if (this.flags.has(ctor)) {
        return false;
      }

      this.flags.set(ctor, flag);
      return true;
    }
  }, {
    key: "remove",
    value: function remove(ctor) {
      if (!this.flags.has(ctor)) {
        return null;
      }

      var ret = this.flags.get(ctor);
      this.flags.delete(ctor);
      return ret;
    }
  }, {
    key: "removeInstance",
    value: function removeInstance(flag) {
      var ctor = flag.constructor;

      if (typeof ctor !== 'function' || !ctor.TAG) {
        throw new Error('Provided value is not ADT flag');
      }

      return this.flags.delete(ctor);
    }
  }, {
    key: "serialize",
    value: function serialize() {
      var arr = Array.from(this.flags.values());
      return arr.map(AdtFlag_1.AdtFlag.serialize);
    }
  }, {
    key: "addDeserialized",
    value: function addDeserialized(obj) {
      var flag = this.base.deserialize(obj);
      this.add(flag);
      return flag;
    }
  }, {
    key: "toString",
    value: function toString() {
      var ret = 'FlagSet: ' + this.base.TAG + ': {';
      var cnt = 0;
      this.flags.forEach(function (v, k) {
        ret += cnt === 0 ? '' : ', ';
        ret += k.TAG + ': ' + v;
        cnt++;
      });
      return ret + '}';
    }
  }], [{
    key: "of",
    value: function of(base) {
      var ret = new FlagSet(base);

      for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        values[_key - 1] = arguments[_key];
      }

      for (var _i = 0; _i < values.length; _i++) {
        var it = values[_i];
        ret.add(it);
      }

      return ret;
    }
  }, {
    key: "merge",
    value: function merge() {
      for (var _len2 = arguments.length, sets = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        sets[_key2] = arguments[_key2];
      }

      if (sets.length === 0) {
        throw new Error('Empty set array');
      }

      var base = sets[0].base;
      var ret = new FlagSet(base);

      for (var _i2 = 0; _i2 < sets.length; _i2++) {
        var set = sets[_i2];

        if (base !== set.base) {
          throw new Error('Only sets having same base can be merged');
        }

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = set[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var flag = _step.value;
            ret.add(flag);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }

      return ret;
    }
  }, {
    key: "excludeFlags",
    value: function excludeFlags(flagSet, excludedFlags) {
      if (flagSet.size() === 0 || excludedFlags.length === 0) {
        return flagSet;
      }

      var excl = new Set(excludedFlags);
      var ret = new FlagSet(flagSet.base);
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = flagSet[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var flag = _step2.value;
          var ctor = flag.constructor;

          if (!excl.has(ctor)) {
            ret.add(flag);
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return ret;
    }
  }]);

  return FlagSet;
}();

exports.FlagSet = FlagSet;